import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Msal } from '../services/msal.service';

@Injectable()
export class Utils {
  constructor(private msal: Msal) {}

  public GetIfTokenExpired() {
    const isTokenExpired = this.msal.isUserAuthenticated && this.msal.IsTokenExpired();
    return isTokenExpired;
  }

  public GetRequestHeaders(saraSessionId?: string): HttpHeaders {
    if (!saraSessionId) {
      saraSessionId = this.GenerateGuid();
    }

    const token = this.msal.getToken();
    const header = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', ` Bearer ${token}`)
      .set('x-ms-sara-api-version', 'schema-v1')
      .set('SaraSessionId', saraSessionId);

    return header;
  }

  public GenerateGuid(): string {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now(); // use high-precision timer if available
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  public getAliasFromEmail(email: string) {
    if (!email) {
      return;
    }

    const parts: string[] = email.split('@');
    return parts[0];
  }

  public ValidUrl(str: string) {
    const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if (regex.test(str)) {
      return true;
    }
    return false;
  }

  public ValidBuildVersion(str) {
    const regex = /^\d+(\.\d+){3}$/;
    if (regex.test(str)) {
      return true;
    }
    return false;
  }

  public ValidGUID(str) {
    const regex = /^[{(]?[0-9A-Fa-f]{8}[-]?(?:[0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$/;
    if (regex.test(str)) {
      return true;
    }
    return false;
  }

  public ValidNumberLetterOnly(str) {
    const regex = /^[a-zA-Z0-9]*$/;
    if (regex.test(str)) {
      return true;
    }
    return false;
  }

  public ValidNumberOnly(str) {
    const regex = /^[0-9]*$/;
    if (regex.test(str)) {
      return true;
    }
    return false;
  }

  public getLocalTimeFromUtcTime(utcTime: Date) {
    if (!utcTime) {
      return null;
    }

    const utcDate = utcTime.toString();
    const localDate = new Date(utcDate);
    return localDate.toLocaleString();
  }

  public searchField(fieldValue: string, searchTerm: string) {
    return (
      !!fieldValue &&
      (fieldValue.trim().toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
        searchTerm.trim().toLowerCase().includes(fieldValue.trim().toLowerCase()))
    );
  }
}
